export interface ILateBloodDraw {
    serologyTrackingId: number,
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientCenterAlias: string,
    swap: string,
    kidneyPickupDate: string,
    bloodDrawDate: string,
    delta: number
}
